import { render } from "./GoalChart.vue?vue&type=template&id=26ed3bdf&scoped=true"
import script from "./GoalChart.vue?vue&type=script&lang=js"
export * from "./GoalChart.vue?vue&type=script&lang=js"

import "./GoalChart.vue?vue&type=style&index=0&id=26ed3bdf&scoped=true&lang=css"

import exportComponent from "D:\\AppDev\\__\\_goblinbank\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ed3bdf"]])

export default __exports__